window.addEventListener("DOMContentLoaded", (event) => {
  var swiperCharities = new Swiper(".charitiesSwipper", {
    slidesPerView: 3,
    grid: {
      rows: 1,
    },
    autoplay: {
      delay: 3000,
    },
    loop: true,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      // when window width is >= 480px
      100: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      680: {
        slidesPerView: 3,
        spaceBetween: 30
      },
    }
  });
});
